module.exports = __webpack_public_path__ + "img/icon-shield.e566d018.svg";